import { Color } from "three";
import type { Catalogue } from "../../data/schema";

const scratch = new Color();

/** Linear RGB triples for the given bodies, in the order of `indices`. */
export function colorAttribute(bodies: Catalogue, indices: number[]): Float32Array {
  const out = new Float32Array(3 * indices.length);
  indices.forEach((index, k) => {
    scratch.set(bodies[index].physical.color);
    out[3 * k] = scratch.r;
    out[3 * k + 1] = scratch.g;
    out[3 * k + 2] = scratch.b;
  });
  return out;
}
